/* ==== Cart form wiring (no inline script) ========================== */
const COUNTRIES=["Afghanistan","Aland Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Ascension Island","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo","Cook Islands","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Democratic Republic of the Congo","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands (Malvinas)","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Holy See (Vatican City State)","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Ivory Coast / Cote d`Ivoire","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea","Korea","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","North Macedonia","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Barthelemy","Saint Helena","Saint Kitts and Nevis","Saint Lucia","Saint Martin","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Sweden","Switzerland","Syrian Arab Republic","Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","United States Minor Outlying Islands","Uruguay","Uzbekistan","Vanuatu","Venezuela","Vietnam","Virgin Islands","Wallis and Futuna","Yemen","Zambia","Zimbabwe"];

function $(s,r=document){return r.querySelector(s)}
function $all(s,r=document){return Array.from(r.querySelectorAll(s))}
function debounce(fn,wait){let t;return function(){clearTimeout(t);const a=arguments,c=this;t=setTimeout(()=>fn.apply(c,a),wait)}}

/* Fill country selects if empty */
function hydrateCountrySelects(scope){
  $all('select[name="Geburtsland"], select[name="Staatsangeh\u00f6rigkeit"]', scope).forEach(s=>{
    if (s.options.length<=1){
      COUNTRIES.forEach(c=>{const o=document.createElement('option'); o.value=c; o.textContent=c; s.appendChild(o);});
    }
  });
}

/* TELC/DTZ g?r?n?rl?g? */
function applyVariant(scope){
  const v=(scope.getAttribute('data-variant')||'TELC').toUpperCase();
  const telc=scope.querySelector('.group-telc'), dtz=scope.querySelector('.group-dtz');
  if(v==='DTZ'){ if(dtz) dtz.style.display='contents'; if(telc) telc.style.display='none'; }
  else { if(telc) telc.style.display='contents'; if(dtz) dtz.style.display='none'; }
}

/* Attributes to Shopify */
function collectAttributes(scope){
  const map={};
  $all('input,select,textarea', scope).forEach(el=>{
    if(!el.name || el.type==='file') return;
    const val = el.type==='checkbox' ? (el.checked?'Ja':'') : (el.value||'').trim();
    if(val!=='') map[el.name]=val;
  });
  return map;
}
async function syncAttributes(scope){
  const attributes=collectAttributes(scope);
  try{ await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})}); }catch(e){}
}

/* Validate visible required fields */
function validate(scope){
  const v=(scope.getAttribute('data-variant')||'TELC').toUpperCase();
  let err=0;
  function req(sel){
    const el=scope.querySelector(sel);
    if(!el || el.offsetParent===null) return;
    const val=el.type==='checkbox'?(el.checked?'1':''):(el.value||'').trim();
    el.style.borderColor=''; if(!val){err=1; el.style.borderColor='#ef4444'; el.focus();}
  }
  req('input[name="Contract"]');
  req('select[name="Anrede"]');
  req('input[name="Teilnehmer*in (Vorname)"]');
  req('input[name="Teilnehmer*in (Name)"]');
  req('input[name="Telefon"]');
  if(v==='TELC'){
    req('select[name="Geburtsland"]'); req('input[name="Geburtsort"]'); req('input[name="Geburtsdatum"]');
    req('select[name="Muttersprache"], input[name="Muttersprache"]');
    req('select[name="Staatsangeh\u00f6rigkeit"], input[name="Staatsangeh\u00f6rigkeit"]');
  }else{
    req('input[name="Geburtsort"]'); req('input[name="Geburtsdatum"]'); req('input[name="pkz-nummer"]'); req('input[name="Ausweisnummer"]');
  }
  const warn=$('#x-consent-warn'); if(warn){ warn.style.display = $('#x-consent')?.checked ? 'none':'block'; }
  return err;
}

/* Enable/disable checkout + express */
function toggleCheckout(enabled){
  const mainBtn=$('#cart-checkout');
  const aBtn=document.querySelector('.action-group .button-checkout');
  const dynamic=$('#dynamic-checkout-cart');
  [mainBtn,aBtn].forEach(btn=>{
    if(!btn) return;
    if(enabled){ btn.classList.remove('x-disabled'); btn.removeAttribute('aria-disabled'); if(btn.tagName==='BUTTON') btn.disabled=false; }
    else{ btn.classList.add('x-disabled'); btn.setAttribute('aria-disabled','true'); if(btn.tagName==='BUTTON') btn.disabled=true; }
  });
  if(dynamic){ enabled ? dynamic.classList.remove('x-disabled') : dynamic.classList.add('x-disabled'); }
}

/* Bind events */
function wire(scope){
  hydrateCountrySelects(scope);
  applyVariant(scope);

  $all('input,select,textarea', scope).forEach(el=>{
    el.addEventListener('input', debounce(()=>syncAttributes(scope),350));
    el.addEventListener('change', debounce(()=>syncAttributes(scope),50));
  });

  const consent=$('#x-consent',scope);
  if(consent){ consent.addEventListener('change',()=>toggleCheckout(consent.checked)); toggleCheckout(consent.checked); }

  function onCheckout(e){
    const disabled=e.currentTarget.classList.contains('x-disabled') || e.currentTarget.getAttribute('aria-disabled')==='true';
    if(disabled){ e.preventDefault(); e.stopPropagation(); return false; }
    if(validate(scope)){ e.preventDefault(); e.stopPropagation(); return false; }
    e.preventDefault(); e.stopPropagation();
    syncAttributes(scope).then(()=>{ window.location.href='/customer_authentication/login?return_to=%2Fcheckout'; });
    return false;
  }
  const mainBtn=$('#cart-checkout'); if(mainBtn) mainBtn.addEventListener('click', onCheckout, true);
  const aBtn=document.querySelector('.action-group .button-checkout'); if(aBtn) aBtn.addEventListener('click', onCheckout, true);

  // initial push for express
  syncAttributes(scope);
}

/* Init only when block exists */
(function init(){
  function run(){ const scope=document.getElementById('x-cart-extra'); if(scope) wire(scope); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
